import {configureStore} from '@reduxjs/toolkit';
import coinsReducer from './GlobalState';

export const store = configureStore({
    reducer: {
        coins: coinsReducer,
    },
});